module.exports = "/ui/main/images/cart_icon_white.svg?616d9371966df758092a85528445dadb";